import { render } from "./Update.vue?vue&type=template&id=02221ff8"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
script.render = render

export default script